import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * @tags styled, badge, label
 */
const Badge = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  ${(props) => {
    let backgroundColor;
    let borderColor;
    switch (props.color) {
      case 'green':
        backgroundColor = props.theme.colors.semantic.lightGreen;
        borderColor = props.theme.colors.semantic.green;
        break;
      case 'pink':
        backgroundColor = props.theme.colors.primary.brightPink;
        borderColor = props.theme.colors.primary.magenta;
        break;
      case 'purple':
        backgroundColor = props.theme.colors.primary.brightPurple;
        borderColor = props.theme.colors.primary.purple;
        break;
      case 'amber':
      default:
        backgroundColor = props.theme.colors.primary.brightYellow;
        borderColor = props.theme.colors.semantic.orange;
    }
    return `
      background: ${backgroundColor};
      border-left: 4px solid ${borderColor};
    `;
  }}
  padding: 5px 12px 5px 10px;
  border-radius: 2px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.default.fontFamily};
  font-size: 12px;
  color: ${props => props.theme.colors.neutral.currysBlack};
  display: inline-block;
`;

Badge.displayName = 'Badge';

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['green', 'pink', 'purple', 'amber']),
  qa: PropTypes.string
};

Badge.defaultProps = {
  color: 'green',
  qa: undefined
};

/** @component */
export default Badge;
